/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IEditorResource_Asset } from "../../../resources/ResourceTypes";

export function isImageAsset(assetResource: IEditorResource_Asset): boolean {
	return assetResource?.metaData?.assetMimetype?.toLowerCase().includes("image");
}

export function isVideoAsset(assetResource: IEditorResource_Asset): boolean {
	return assetResource?.metaData?.assetMimetype?.toLowerCase().includes("video");
}
